import { apiPostForm } from "./client";
import { confirmNoncePath } from "./endpoints";

export interface ConfirmNonceResponse {
  ok: boolean;
  nonce: string;
  kind: string;
  target: string;
}

export function requestConfirmNonce(kind: string, target: string) {
  return apiPostForm<ConfirmNonceResponse>(confirmNoncePath, { kind, target });
}
